import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { Command } from '@/plugins/cad/module/core/Command'

/**
 * 绘制单个实体命令，用于绘图工具在交互过程中加入/撤销实体。
 *
 * @typeParam T - 目标实体类型
 */
export class DrawEntityCommand<T extends IEntity = IEntity> extends Command {
  constructor(
    private entity: T,
    private viewManager: CADViewManager,
    private handleUndoStep?: () => void,
    private isCanCommit?: () => boolean,
    private isCanUndoStep?: () => boolean
  ) {
    super()
  }

  /** 将实体加入视图 */
  execute(): void {
    this.viewManager.addEntity(this.entity)
  }

  /** 撤销：从视图中移除实体 */
  undo(): void {
    this.viewManager.deleteEntity(this.entity)
  }

  /** 分步撤销，委托给外部回调 */
  undoStep(): void {
    this.handleUndoStep?.()
  }

  /**
   * 是否支持分步撤销。
   *
   * @returns 由外部回调决定，默认返回 false
   */
  canUndoStep(): boolean {
    return this.isCanUndoStep ? this.isCanUndoStep() : false
  }

  /**
   * 是否允许提交命令。
   *
   * @returns 由外部回调决定，默认返回 true
   */
  canCommit(): boolean {
    return this.isCanCommit ? this.isCanCommit() : true
  }
}
